import { useState, useCallback } from 'react';
import quarkusApi from '../../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useProcedureActions() {
  const [isLoading, setLoading] = useState(false);

  const remove = useCallback((procedureId) => {
    setLoading(true);
    return quarkusApi
      .delete(`/procedures/${procedureId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const generateCharge = useCallback((treatmentId, procedureId) => {
    setLoading(true);
    return quarkusApi
      .get(`/treatments/${treatmentId}/procedures/${procedureId}/generate-charge`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const finish = useCallback((procedureId) => {
    setLoading(true);
    return quarkusApi
      .patch(`/procedures/${procedureId}/finish`, null, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const rectify = useCallback((procedureId, rectification) => {
    setLoading(true);
    return quarkusApi
      .put(`/procedures/${procedureId}/rectify`, rectification, authHeader())
      .finally(() => setLoading(false));
  }, []);

  return { remove, generateCharge, finish, rectify, isLoading };
}
